"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section ref={ref} className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-fixed bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1458826/img/specialty_coffee_hero_background.png)]" style={{
      transform: isVisible ? "translateY(0)" : "translateY(-8%)",
      transition: "transform 1200ms cubic-bezier(0.25, 0.46, 0.45, 0.94)"
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-dark-background/80 via-dark-background/70 to-dark-background/90" />

      {}
      <div className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
        {}
        <h1 className={`font-display text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-dark mb-6 transition-all duration-500 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
        transitionDelay: isVisible ? "0ms" : "0ms"
      }}>
          Discover Canada's Finest Specialty Coffee
        </h1>

        {}
        <p className={`text-xl md:text-2xl text-foreground-dark/90 mb-10 font-sans transition-all duration-500 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`} style={{
        transitionDelay: isVisible ? "300ms" : "0ms"
      }}>
          Curated roasters ranked by Google and Yotpo reviews. Find your
          perfect cup today.
        </p>

        {}
        <div className={`transition-all duration-500 ${isVisible ? "opacity-100" : "opacity-0"}`} style={{
        transitionDelay: isVisible ? "600ms" : "0ms"
      }}>
          <Link to="/RoastersPage">
            <Button size="lg" className="btn-primary text-lg px-8 py-4 shadow-medium hover:shadow-strong animate-pulse hover:animate-none">
              Explore Top Roasters
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}